import { Button } from 'antd'
import styled from 'styled-components'

export const ButtonCustom = styled(Button)`
  width: 200px;
`

export const ButtonWrapper = styled.div`
  display: flex;
`

export const ButtonActionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 30px;
  margin-left: 455px;
`
export const CustomRowTable = styled.div<{ type?: string }>`
  text-align: ${({ type }) => type};
`
